import React from 'react';
import './MobileCard.css';

interface MobileCardField {
  label: string;
  value: React.ReactNode;
  className?: string;
}

interface MobileCardProps {
  title: string;
  subtitle?: string;
  badge?: React.ReactNode;
  fields: MobileCardField[];
  actions?: React.ReactNode;
  onClick?: () => void;
  className?: string;
}

export const MobileCard: React.FC<MobileCardProps> = ({
  title,
  subtitle,
  badge,
  fields,
  actions,
  onClick,
  className = '',
}) => {
  return (
    <div
      className={`mobile-card ${className} ${onClick ? 'clickable' : ''}`}
      onClick={onClick}
    >
      <div className="mobile-card-header">
        <div className="mobile-card-title-group">
          <h3 className="mobile-card-title">{title}</h3>
          {subtitle && <span className="mobile-card-subtitle">{subtitle}</span>}
        </div>
        {badge && <div className="mobile-card-badge">{badge}</div>}
      </div>

      <div className="mobile-card-fields">
        {fields.map((field, index) => (
          <div key={index} className={`mobile-card-field ${field.className || ''}`}>
            <span className="mobile-card-label">{field.label}</span>
            <span className="mobile-card-value">{field.value}</span>
          </div>
        ))}
      </div>

      {actions && (
        <div className="mobile-card-actions">
          {actions}
        </div>
      )}
    </div>
  );
};

// Hook to detect mobile screen size
export const useIsMobile = (breakpoint: number = 768): boolean => {
  const [isMobile, setIsMobile] = React.useState(
    typeof window !== 'undefined' ? window.innerWidth < breakpoint : false
  );

  React.useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < breakpoint);
    };

    window.addEventListener('resize', handleResize);
    handleResize(); // Check on mount

    return () => window.removeEventListener('resize', handleResize);
  }, [breakpoint]);

  return isMobile;
};

export default MobileCard;
